import * as React from "react";
import { useDeepCompareEffect } from "use-deep-compare";
import { useResize } from "../hooks/useResize";
import { Colors } from "../util/Colors";
import { OptionalTooltip } from "./OptionalTooltip";

export type ITableLabelProps = {
    children: string;
    style?: React.CSSProperties;
    tooltip?: string;
    maxLines?: number;
};

export const TableLabel = ({ children, style, tooltip, maxLines = 1 }: ITableLabelProps) => {
    const [isOverflowing, setIsOverflowing] = React.useState(false);
    const ref = React.useRef<HTMLDivElement>(null);
    const dimensions = useResize(ref);

    useDeepCompareEffect(() => {
        if (ref.current) {
            setIsOverflowing(
                maxLines === 1
                    ? ref.current.offsetWidth < ref.current.scrollWidth
                    : ref.current.offsetHeight < ref.current.scrollHeight,
            );
        }
    }, [children, dimensions, maxLines]);

    const tooltipMessage = tooltip ?? children;

    const clampStyle: React.CSSProperties =
        maxLines === 1
            ? { whiteSpace: "nowrap" }
            : {
                  display: "-webkit-box",
                  WebkitLineClamp: maxLines,
                  WebkitBoxOrient: "vertical",
                  whiteSpace: "normal",
              };

    return (
        <OptionalTooltip title={isOverflowing || tooltip ? tooltipMessage : undefined}>
            <div
                style={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    color: Colors.TEXT_BOLD,
                    fontWeight: 500,
                    textAlign: "center",
                    ...clampStyle,
                    ...style,
                }}
                ref={ref}
            >
                {children}
            </div>
        </OptionalTooltip>
    );
};
